// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"6a28b760","865":"6a28b760","914":"6a28b760"}[chunkId] + ".chunk.css";
};